import React from "react";

export default function KPICard({
  label,
  value,
  hint,
  icon: Icon,
  tone = "neutral",
  testId,
}) {
  const toneRing =
    tone === "blue"
      ? "ring-blue-100 text-blue-900"
      : tone === "red"
      ? "ring-red-100 text-red-900"
      : tone === "green"
      ? "ring-green-100 text-green-900"
      : "ring-gray-100 text-gray-900";

  return (
    <div className="crtm-card p-5" data-testid={testId}>
      <div className="flex justify-between items-start mb-3">
        <span className="kpi-label">{label}</span>
        {Icon && (
          <div
            className={`w-9 h-9 rounded-lg bg-gray-50 ring-1 flex items-center justify-center ${toneRing}`}
          >
            <Icon size={18} strokeWidth={1.75} />
          </div>
        )}
      </div>
      <div className="kpi-value" data-testid={`${testId}-value`}>
        {value}
      </div>
      {hint && <div className="text-xs text-gray-500 mt-1.5">{hint}</div>}
    </div>
  );
}
